import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
const logos = [{
  name: 'IPSE',
  src: 'https://cdn.magicpatterns.com/uploads/2W9yKM2fQuD92ZqnNaVAKU/ipse.png'
}, {
  name: 'REDORG',
  src: 'https://cdn.magicpatterns.com/uploads/1HgAPqaXsStHNkZsky1bBt/Logo_REDORG.png'
}, {
  name: 'Zumpago',
  src: 'https://cdn.magicpatterns.com/uploads/2Tie2NHpzrXru3j8x29kSn/zumpago.png'
}, {
  name: 'TicketMaestro',
  src: 'https://cdn.magicpatterns.com/uploads/ejLn1Vh1CNoMAbR23JcD4a/logo_ticketmaestro_positivo.png'
}, {
  name: 'Benefika',
  src: 'https://cdn.magicpatterns.com/uploads/okG7CtABtdj5VW44Vf3UCV/logo_benefica_positivo.png'
}, {
  name: 'CEDES',
  src: 'https://cdn.magicpatterns.com/uploads/g1iyCFLjpF4ZdMMNprR9tr/Logo_CEDES_Fondo_Trasparente_V2.0.png'
}];
export function LogoScroll() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  // Quadruple logos for seamless infinite scroll
  const allLogos = [...logos, ...logos, ...logos, ...logos];
  return <section className="py-16 bg-navy-800/30 overflow-hidden" ref={ref} data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} className="text-center text-lg text-gray-400 mb-10 font-medium" data-id="element-180">
          Algunas de las plataformas que ya usan{' '}
          <span className="text-teal-500 font-semibold" data-id="element-181">TruID</span>
        </motion.p>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={isInView ? {
      opacity: 1
    } : {
      opacity: 0
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="relative" data-id="element-182">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-navy-900 to-transparent z-10 pointer-events-none" data-id="element-183"></div>
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-navy-900 to-transparent z-10 pointer-events-none" data-id="element-184"></div>

        <div className="flex animate-scroll" style={{
        width: 'max-content'
      }} data-id="element-185">
          {allLogos.map((logo, index) => <div key={`${logo.name}-${index}`} className="flex-shrink-0 mx-10 flex items-center justify-center bg-white rounded-xl px-6 py-3" data-id="element-186">
              <img src={logo.src} alt={logo.name} className="h-14 md:h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity" data-id="element-187" />
            </div>)}
        </div>
      </motion.div>
    </section>;
}